module.exports = __webpack_public_path__ + "static/screen1-914c9c1537ace3500153e4fb7f89a616.webp";